// extracted by mini-css-extract-plugin
export var tosLink = "_bx-0";